import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import Crumb from './Crumb';

const TopologyCrumb = ({ href, translationKey }) => (
  <Crumb label={trans(translationKey)} href={href} position={4} />
);

TopologyCrumb.propTypes = {
  href: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired
};

export default TopologyCrumb;
